import { Link, Typography } from "@mui/material";
import { type FC } from "react";
import { NavLink } from "react-router";

import { ROUTES } from "~/constants/routing";
import type { ICategory } from "~/types/category";

import * as Styled from "./Breadcrumbs.styles";

interface IBreadcrumbsProps {
  title: string;
  category?: ICategory | null;
}

export const Breadcrumbs: FC<IBreadcrumbsProps> = ({ title, category }) => {
  return (
    <Styled.Root aria-label="breadcrumb" separator="|">
      <Link
        component={NavLink}
        to={ROUTES.main.createURL()}
        color="inherit"
        variant="caption"
      >
        Home
      </Link>
      {category && (
        <Link
          component={NavLink}
          to={ROUTES.category.createURL(String(category.slug))}
          color="inherit"
          variant="caption"
        >
          {category.name}
        </Link>
      )}
      <Typography variant="caption" sx={{
        color: "text.primary"
      }}>
        {title}
      </Typography>
    </Styled.Root>
  );
};
